import { Component } from '@angular/core';

@Component({
  selector: 'app-header-public',
  templateUrl: './header-public.component.html'
})
export class HeaderPublicComponent {

}
